import React from 'react';

import { Button } from '@mui/material';
import MapRoundedIcon from '@mui/icons-material/MapRounded';
import FormatListBulletedRoundedIcon from '@mui/icons-material/FormatListBulletedRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';

import { COLOR_PRIMARY_2 } from 'src/utils/colors';

const ShowFullMapButton = ({
  showFullMap,
  setShowFullMap,
}: {
  showFullMap: boolean;
  setShowFullMap: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <Button
      onClick={() => setShowFullMap(!showFullMap)}
      variant="outlined"
      size="small"
      sx={{
        color: COLOR_PRIMARY_2,
        borderColor: COLOR_PRIMARY_2,
        '&:hover': {
          backgroundColor: COLOR_PRIMARY_2,
          color: 'white',
        },
      }}
    >
      {showFullMap ? <KeyboardArrowRightRoundedIcon /> : <KeyboardArrowLeftRoundedIcon />}
      {showFullMap ? (
        <FormatListBulletedRoundedIcon sx={{ ml: 1 }} />
      ) : (
        <MapRoundedIcon sx={{ ml: 1 }} />
      )}{' '}
      {showFullMap ? 'Split View' : 'Full Map'}{' '}
    </Button>
  );
};

export default ShowFullMapButton;
